import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './GalleryPage.css';

// Import sample images and videos (replace with your actual media)
import pestGuard2 from '../assets/Images/f1.jpg';
import pestGuard3 from '../assets/Images/f2.jpg';
import pestGuard4 from '../assets/Images/f3.jpg';
import pestGuard5 from '../assets/Images/f4.jpg';
import pestGuard6 from '../assets/Images/pest1.jpg';
import pestGuard7 from '../assets/Images/pest2.jpg';
import pestGuard8 from '../assets/Images/p-1.png';
import pestGuard9 from '../assets/Images/p-2.png';
import pestGuard10 from '../assets/Images/p-3.png';
import pestGuard11 from '../assets/Images/f5.png';
import pestGuard12 from '../assets/Images/f6.png';
import pestGuard13 from '../assets/Images/f8.png';

// Import videos
import video1 from '../assets/videos/v1.mp4';
import video2 from '../assets/videos/v2.mp4';
import video7 from '../assets/videos/video4.mp4';
// import video10 from '../assets/videos/video7.mp4';

const GalleryPage = () => {
  const [activeTab, setActiveTab] = useState('photos');
  const [selectedItem, setSelectedItem] = useState(null);
  const [hoveredVideo, setHoveredVideo] = useState(null);

  // Sample gallery items (replace with your actual content)
  const galleryItems = {
    photos: [
     
      { id: 4, type: 'image', src: pestGuard5, title: 'Junction Box For Poross Pipe' },
      { id: 5, type: 'image', src: pestGuard6, title: 'Chemical Injection'},
      { id: 6, type: 'image', src: pestGuard7, title: 'Chemical Injection'},
      { id: 7, type: 'image', src: pestGuard8, title: 'Sanitization'},
      { id: 8, type: 'image', src: pestGuard9, title: 'Sanitization'},
      { id: 9, type: 'image', src: pestGuard10, title: 'Sanitization'},
      { id: 10, type: 'image', src: pestGuard11, title: 'Poross Pipe Installation'},
      { id: 11, type: 'image', src: pestGuard12, title: 'Poross Pipe Installation'},
      { id: 12, type: 'image', src: pestGuard13, title: 'House Sanitization'},
      { id: 1, type: 'image', src: pestGuard2, title: 'Damage after termite'},
      { id: 2, type: 'image', src: pestGuard3, title: 'Damage after termite'},
      { id: 3, type: 'image', src: pestGuard4, title: 'Damage after termite'},
    ],
    videos: [
      { id: 1, type: 'video', src: video1, title: 'poross Pipe Fitting'},
      { id: 2, type: 'video', src: video2, title: 'Chemical Injection'},
      { id: 3, type: 'video', src: video7, title: 'Chemical Injection'},
      // { id: 10, type: 'video', src: video10, title: 'Commercial Pest Control', description: 'Comprehensive pest management for businesses' }
    ]
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const openModal = (item) => {
    setSelectedItem(item);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedItem(null);
    document.body.style.overflow = 'auto';
  };



  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="gallery-page"
    >
      {/* Gallery Header */}
      <div className="gallery-header">
        <div className="container">
          <h1 className="display-4 mb-4">Glimpses</h1>
          <p className="lead">Explore our pest control services through photos and videos</p>
        </div>
      </div>

      <div className="container">
        {/* Tabs */}
        <div className="gallery-tabs d-flex justify-content-center gap-4 mb-4">
          <button
            className={`gallery-tab ${activeTab === 'photos' ? 'active' : ''}`}
            onClick={() => handleTabChange('photos')}
          >
            Photos
          </button>
          <button
            className={`gallery-tab ${activeTab === 'videos' ? 'active' : ''}`}
            onClick={() => handleTabChange('videos')}
          >
            Videos
          </button>
        </div>



        {/* Gallery Grid */}
        <motion.div 
          className="gallery-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {galleryItems[activeTab].map((item) => (
            <motion.div
              key={item.id}
              className="gallery-item"
              onClick={() => openModal(item)}
              whileHover={{ y: -5 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              {item.type === 'image' ? (
                <img src={item.src} alt={item.title} />
              ) : (
                <div className="video-thumbnail-container">
                  <video
                    src={item.src}
                    muted
                    preload="metadata"
                    ref={(el) => {
                      if (el) {
                        el.pause();
                        if (hoveredVideo === item.id) {
                          el.play().catch(e => console.log('Video play error:', e));
                        } else {
                          el.currentTime = 0;
                        }
                      }
                    }}
                  />
                  <div 
                    className="video-hover-overlay"
                    onMouseEnter={() => setHoveredVideo(item.id)}
                    onMouseLeave={() => setHoveredVideo(null)}
                  />
                </div>
              )}
              <div className="gallery-overlay">
                <i className="bi bi-zoom-in fs-1"></i>
              </div>
              <div className="gallery-caption">
                <h5>{item.title}</h5>
                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Modal */}
        <AnimatePresence>
          {selectedItem && (
            <motion.div
              className="gallery-modal show"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeModal}
            >
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={closeModal}>
                  <i className="bi bi-x"></i>
                </button>
                {selectedItem.type === 'image' ? (
                  <img src={selectedItem.src} alt={selectedItem.title} />
                ) : (
                  <video src={selectedItem.src} controls />
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Empty State */}
        {galleryItems[activeTab].length === 0 && (
          <div className="text-center py-5">
            <i className="bi bi-image fs-1 text-muted"></i>
            <p className="mt-3">No {activeTab} available at this time.</p>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default GalleryPage;
